export const NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_10 = 10,
  NUMBER_100 = 100;
